<template>
  <div class="l-container AppointmentsIndex2">

    <div class="pager"><i class="fa fa-arrow-left" @click="prev"></i><span class="nowIndex">{{nowIndex + 1}}</span><i class="fa fa-arrow-right" @click="next"></i></div>

    <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'mgr'">
      <export-modal class="export-modal" :obj="obj" :columns="columns" @swi="switchV" @res="reset" @all="all" @def="def">Export</export-modal>
    </template>

    現在表示数 : {{max}}
    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span v-for="(list, index) in columns" :key="index">
      <template v-if="sortColumn === columns[index].code">
        {{ list.name }} : {{sortState}}
      </template>
    </span>

    <h1 class="m-label m-label-custom" @click="switchColumns('columnsFlg')" v-bind:class="{ 'slideActive': columnsFlg }" v-ripple>項目</h1>

    <template v-if="columnsFlg">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="def()">DEFAULT</btn>

        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchV(index)" v-bind:class="{ 'active': columns[index].show }">{{ list.name }}</btn>

      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <div style="display: flex; margin-top: 10px">
      <btn class="m-btn--column" @click.native="btn1">体験案内</btn>
      <btn class="m-btn--column" @click.native="btn2">前日確認</btn>
    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c class="sticky-1"></td-c>
          <template v-if="columns[0].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.sending_check" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.confirm_check" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c class="sticky-1">
              <input v-model="search.id" type="text" @keyup="searchTable()" placeholder="">
            </td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c class="sticky-1">
              <input v-model="search.family_id" type="text" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[4].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[5].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[6].show"><td-c class="sticky-1"><input v-model="search.name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[7].show"><td-c class="sticky-1"><input v-model="search.kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[8].show"><td-c class="sticky-1"><input v-model="search.zip" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[9].show">
            <td-c class="select sticky-1">
              <multiselect v-model="watch.pref" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="prefs" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[10].show"><td-c class="sticky-1"><input v-model="search.address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[11].show"><td-c class="sticky-1"><input v-model="search.tel1" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[12].show"><td-c class="sticky-1"><input v-model="search.tel2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[13].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.preferred_contact" :options="preferred_contact" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[14].show"><td-c class="sticky-1"><input v-model="search.contact_timezone" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[15].show"><td-c class="sticky-1"><input v-model="search.fax" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[16].show"><td-c class="sticky-1"><input v-model="search.mail" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[17].show"><td-c class="sticky-1"><input v-model="search.contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[18].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.contact_method" :options="contact_method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-1">
              <multiselect v-model="watch.support" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="support" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show">
            <td-c class="select sticky-1">
              <multiselect v-model="watch.missing_detail" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="missing_detail" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[21].show">
            <td-c class="select sticky-1">
              <multiselect v-model="watch.contact_later" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="contact_later" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[22].show"><td-c class="sticky-1"><input v-model="search.next_contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[23].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.next_contact_method" :options="next_contact_method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[24].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.result" :options="result" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[25].show"><td-c class="sticky-1"><input v-model="search.acquisition_date[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[26].show"><td-c class="sticky-1"><input v-model="search.acquisition_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[27].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.ap_type" :options="ap_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[28].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.medium1" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[29].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.medium2" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[30].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.medium3" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[31].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.hp_browse" :options="hp_browse" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[32].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.hp_type" :options="hp_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[33].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[34].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.gender" :options="gender" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[35].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.school_type" :options="school_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[36].show"><td-c class="sticky-1"><input v-model="search.school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[37].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.school_stage" :options="school_stage" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[38].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[39].show"><td-c class="sticky-1"><input v-model="search.memo" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[40].show"><td-c class="sticky-1"><input v-model="search.dm" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[41].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.dm_information" :options="dm_information" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[42].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.shop_type" :options="shop_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[43].show"><td-c class="sticky-1"><input v-model="search.shop_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[44].show"><td-c class="sticky-1"><input v-model="search.visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[45].show"><td-c class="sticky-1"><input v-model="search.visit_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[46].show"><td-c class="sticky-1"><input v-model="search.next_visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[47].show"><td-c class="sticky-1"><input v-model="search.next_visit_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[48].show"><td-c class="sticky-1"><input v-model="search.request_of_day_of_week" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[49].show"><td-c class="sticky-1"><input v-model="search.request_of_day_of_week_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[50].show"><td-c class="sticky-1"><input v-model="search.person" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[51].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.contact_person" :options="contact_person" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[52].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.parking" :options="parking" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[53].show"><td-c class="sticky-1"><input v-model="search.parking_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[54].show"><td-c class="sticky-1"><input v-model="search.sub_f_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[55].show"><td-c class="sticky-1"><input v-model="search.sub_l_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[56].show"><td-c class="sticky-1"><input v-model="search.sub_f_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[57].show"><td-c class="sticky-1"><input v-model="search.sub_l_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[58].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.sub_gender" :options="gender" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[59].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.sub_school_type" :options="school_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[60].show"><td-c class="sticky-1"><input v-model="search.sub_school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[61].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.sub_school_stage" :options="school_stage" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[62].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.sub_grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[63].show"><td-c class="sticky-1"><input v-model="search.achievement" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[64].show"><td-c class="sticky-1"><input v-model="search.learning" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[65].show"><td-c class="sticky-1"><input v-model="search.learning_start_period" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[66].show"><td-c class="sticky-1"><input v-model="search.learning_nervous" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[67].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.learning_result" :options="learning_result" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[68].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.learning_continuation" :options="learning_continuation" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[69].show"><td-c class="sticky-1"><input v-model="search.sub_achievement" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[70].show"><td-c class="sticky-1"><input v-model="search.sub_learning" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[71].show"><td-c class="sticky-1"><input v-model="search.sub_learning_start_period" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[72].show"><td-c class="sticky-1"><input v-model="search.sub_learning_nervous" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[73].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.sub_learning_result" :options="learning_result" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[74].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.sub_learning_continuation" :options="learning_continuation" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[75].show"><td-c class="sticky-1"><input v-model="search.attended" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[76].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.fathers_involvement" :options="fathers_involvement" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[77].show"><td-c class="sticky-1"><input v-model="search.notices" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[78].show"><td-c class="sticky-1"><input v-model="search.sending_products" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[79].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.sending_method" :options="sending_method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[80].show"><td-c class="sticky-1"><input v-model="search.sending_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[81].show"><td-c class="sticky-1"><input v-model="search.sending_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[82].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transmission_item_company" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[83].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transmission_item_course" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[84].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transmission_item_visitor" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[85].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transmission_item_purpose" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[86].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transmission_item_requiredtime" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[87].show"><td-c class="sticky-1"><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[88].show"><td-c class="sticky-1"><input v-model="search.note" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c class="sticky-2"></td-c>
          <template v-if="columns[0].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_sending_check" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_confirm_check" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="columns[3].show"><td-c class="sticky-2"><input v-model="search.not_family_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[4].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[5].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[6].show"><td-c class="sticky-2"><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[7].show"><td-c class="sticky-2"><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[8].show"><td-c class="sticky-2"><input v-model="search.not_zip" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[9].show">
            <td-c class="select sticky-2">
              <multiselect v-model="watch.not_pref" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="prefs" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[10].show"><td-c class="sticky-2"><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[11].show"><td-c class="sticky-2"><input v-model="search.not_tel1" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[12].show"><td-c class="sticky-2"><input v-model="search.not_tel2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[13].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_preferred_contact" :options="preferred_contact" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[14].show"><td-c class="sticky-2"><input v-model="search.not_contact_timezone" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[15].show"><td-c class="sticky-2"><input v-model="search.not_fax" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[16].show"><td-c class="sticky-2"><input v-model="search.not_mail" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[17].show"><td-c class="sticky-2"><input v-model="search.not_contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[18].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_contact_method" :options="contact_method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-2">
              <multiselect v-model="watch.not_support" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="support" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show">
            <td-c class="select sticky-2">
              <multiselect v-model="watch.not_missing_detail" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="missing_detail" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[21].show">
            <td-c class="select sticky-2">
              <multiselect v-model="watch.not_contact_later" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="contact_later" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[22].show"><td-c class="sticky-2"><input v-model="search.not_next_contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[23].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_next_contact_method" :options="next_contact_method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[24].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_result" :options="result" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[25].show"><td-c class="sticky-2"><input v-model="search.not_acquisition_date[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[26].show"><td-c class="sticky-2"><input v-model="search.not_acquisition_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[27].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_ap_type" :options="ap_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[28].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_medium1" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[29].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_medium2" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[30].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_medium3" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[31].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_hp_browse" :options="hp_browse" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[32].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_hp_type" :options="hp_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[33].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[34].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_gender" :options="gender" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[35].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_school_type" :options="school_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[36].show"><td-c class="sticky-2"><input v-model="search.not_school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[37].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_school_stage" :options="school_stage" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[38].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[39].show"><td-c class="sticky-2"><input v-model="search.not_memo" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[40].show"><td-c class="sticky-2"><input v-model="search.not_dm" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[41].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.not_dm_information" :options="dm_information" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[42].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_shop_type" :options="shop_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[43].show"><td-c class="sticky-2"><input v-model="search.not_shop_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[44].show"><td-c class="sticky-2"><input v-model="search.not_visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[45].show"><td-c class="sticky-2"><input v-model="search.not_visit_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[46].show"><td-c class="sticky-2"><input v-model="search.not_next_visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[47].show"><td-c class="sticky-2"><input v-model="search.not_next_visit_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[48].show"><td-c class="sticky-2"><input v-model="search.not_request_of_day_of_week" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[49].show"><td-c class="sticky-2"><input v-model="search.not_request_of_day_of_week_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[50].show"><td-c class="sticky-2"><input v-model="search.not_person" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[51].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_contact_person" :options="contact_person" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[52].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_parking" :options="parking" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[53].show"><td-c class="sticky-2"><input v-model="search.not_parking_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[54].show"><td-c class="sticky-2"><input v-model="search.not_sub_f_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[55].show"><td-c class="sticky-2"><input v-model="search.not_sub_l_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[56].show"><td-c class="sticky-2"><input v-model="search.not_sub_f_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[57].show"><td-c class="sticky-2"><input v-model="search.not_sub_l_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[58].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_sub_gender" :options="gender" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[59].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_sub_school_type" :options="school_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[60].show"><td-c class="sticky-2"><input v-model="search.not_sub_school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[61].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_sub_school_stage" :options="school_stage" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[62].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_sub_grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[63].show"><td-c class="sticky-2"><input v-model="search.not_achievement" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[64].show"><td-c class="sticky-2"><input v-model="search.not_learning" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[65].show"><td-c class="sticky-2"><input v-model="search.not_learning_start_period" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[66].show"><td-c class="sticky-2"><input v-model="search.not_learning_nervous" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[67].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_learning_result" :options="learning_result" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[68].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_learning_continuation" :options="learning_continuation" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[69].show"><td-c class="sticky-2"><input v-model="search.not_sub_achievement" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[70].show"><td-c class="sticky-2"><input v-model="search.not_sub_learning" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[71].show"><td-c class="sticky-2"><input v-model="search.not_sub_learning_start_period" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[72].show"><td-c class="sticky-2"><input v-model="search.not_sub_learning_nervous" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[73].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_sub_learning_result" :options="learning_result" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[74].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_sub_learning_continuation" :options="learning_continuation" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[75].show"><td-c class="sticky-2"><input v-model="search.not_attended" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[76].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_fathers_involvement" :options="fathers_involvement" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[77].show"><td-c class="sticky-2"><input v-model="search.not_notices" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[78].show"><td-c class="sticky-2"><input v-model="search.not_sending_products" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[79].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_sending_method" :options="sending_method" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[80].show"><td-c class="sticky-2"><input v-model="search.not_sending_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[81].show"><td-c class="sticky-2"><input v-model="search.not_sending_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[82].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transmission_item_company" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[83].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transmission_item_course" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[84].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transmission_item_visitor" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[85].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transmission_item_purpose" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[86].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transmission_item_requiredtime" :options="maru" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[87].show"><td-c class="sticky-2"><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[88].show"><td-c class="sticky-2"><input v-model="search.not_note" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c>№</th-c>
          <th-c v-for="(list, index) in columns" :key="index" v-if="columns[index].show" class="sticky-3" @click.native='sort(columns[index].code)'>{{ list.name }}</th-c>
        </tr-c>

        <tr-c @click.native='linkAppointment(list, index)' slot="tr-td" v-for="(list, index) in mapAppointments" :key="list.id" class="tr_hover" v-bind:class="{ 'now': nowIndex === index }">
          <td-c>{{index + 1}}</td-c>
          <template v-if="columns[0].show"><td-c>{{list.mapSending_check}}</td-c></template>
          <template v-if="columns[1].show"><td-c>{{list.mapConfirm_check}}</td-c></template>
          <template v-if="columns[2].show"><td-c>{{list.id}}</td-c></template>
          <template v-if="columns[3].show"><td-c>{{list.family_id}}</td-c></template>
          <template v-if="columns[4].show">
            <td-c v-if="list.user">{{list.user.user}}</td-c>
            <td-c v-else></td-c>
          </template>
          <template v-if="columns[5].show"><td-c>{{list.mapState}}</td-c></template>
          <template v-if="columns[6].show"><td-c>{{list.f_name}} {{list.l_name}}</td-c></template>
          <template v-if="columns[7].show"><td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c></template>
          <template v-if="columns[8].show"><td-c>{{list.zip}}</td-c></template>
          <template v-if="columns[9].show"><td-c>{{list.mapPref}}</td-c></template>
          <template v-if="columns[10].show"><td-c>{{list.address1}} {{list.address2}}</td-c></template>
          <template v-if="columns[11].show"><td-c>{{list.tel1}}</td-c></template>
          <template v-if="columns[12].show"><td-c>{{list.tel2}}</td-c></template>
          <template v-if="columns[13].show"><td-c>{{list.mapPreferred_contact}}</td-c></template>
          <template v-if="columns[14].show"><td-c>{{list.contact_timezone}}</td-c></template>
          <template v-if="columns[15].show"><td-c>{{list.fax}}</td-c></template>
          <template v-if="columns[16].show"><td-c>{{list.mail}}</td-c></template>
          <template v-if="columns[17].show"><td-c>{{list.contact_date}}</td-c></template>
          <template v-if="columns[18].show"><td-c>{{list.mapContact_method}}</td-c></template>
          <template v-if="columns[19].show"><td-c>{{list.mapSupport}}</td-c></template>
          <template v-if="columns[20].show"><td-c>{{list.mapMissing_detail}}</td-c></template>
          <template v-if="columns[21].show"><td-c>{{list.mapContact_later}}</td-c></template>
          <template v-if="columns[22].show"><td-c>{{list.next_contact_date}}</td-c></template>
          <template v-if="columns[23].show"><td-c>{{list.mapNext_contact_method}}</td-c></template>
          <template v-if="columns[24].show"><td-c>{{list.mapResult}}</td-c></template>
          <template v-if="columns[25].show"><td-c>{{list.acquisition_date}}</td-c></template>
          <template v-if="columns[26].show"><td-c></td-c></template>
          <template v-if="columns[27].show"><td-c>{{list.mapAp_type}}</td-c></template>
          <template v-if="columns[28].show"><td-c>{{list.mapMedium1}}</td-c></template>
          <template v-if="columns[29].show"><td-c>{{list.mapMedium2}}</td-c></template>
          <template v-if="columns[30].show"><td-c>{{list.mapMedium3}}</td-c></template>
          <template v-if="columns[31].show"><td-c>{{list.mapHp_browse}}</td-c></template>
          <template v-if="columns[32].show"><td-c>{{list.mapHp_type}}</td-c></template>
          <template v-if="columns[33].show"><td-c>{{list.mapOffice_id}}</td-c></template>
          <template v-if="columns[34].show"><td-c>{{list.mapGender}}</td-c></template>
          <template v-if="columns[35].show"><td-c>{{list.mapSchool_type}}</td-c></template>
          <template v-if="columns[36].show"><td-c>{{list.school_name}}</td-c></template>
          <template v-if="columns[37].show"><td-c>{{list.mapSchool_stage}}</td-c></template>
          <template v-if="columns[38].show"><td-c>{{list.mapGrade}}</td-c></template>
          <template v-if="columns[39].show"><td-c>{{list.memo}}</td-c></template>
          <template v-if="columns[40].show"><td-c>{{list.dm.slice(0, 7)}}</td-c></template>
          <template v-if="columns[41].show"><td-c>{{list.mapDmInformation}}</td-c></template>
          <template v-if="columns[42].show"><td-c>{{list.mapShop_type}}</td-c></template>
          <template v-if="columns[43].show"><td-c>{{list.shop_name}}</td-c></template>
          <template v-if="columns[44].show"><td-c>{{list.visit_date}}</td-c></template>
          <template v-if="columns[45].show"><td-c>{{list.visit_time}}</td-c></template>
          <template v-if="columns[46].show"><td-c>{{list.next_visit_date}}</td-c></template>
          <template v-if="columns[47].show"><td-c>{{list.next_visit_time}}</td-c></template>
          <template v-if="columns[48].show"><td-c>{{list.request_of_day_of_week}}</td-c></template>
          <template v-if="columns[49].show"><td-c>{{list.request_of_day_of_week_note}}</td-c></template>
          <template v-if="columns[50].show"><td-c>{{list.person}}</td-c></template>
          <template v-if="columns[51].show"><td-c>{{list.mapContact_person}}</td-c></template>
          <template v-if="columns[52].show"><td-c>{{list.mapParking}}</td-c></template>
          <template v-if="columns[53].show"><td-c>{{list.parking_note}}</td-c></template>
          <template v-if="columns[54].show"><td-c>{{list.sub_f_name}}</td-c></template>
          <template v-if="columns[55].show"><td-c>{{list.sub_l_name}}</td-c></template>
          <template v-if="columns[56].show"><td-c>{{list.sub_f_name_kana}}</td-c></template>
          <template v-if="columns[57].show"><td-c>{{list.sub_l_name_kana}}</td-c></template>
          <template v-if="columns[58].show"><td-c>{{list.mapSub_gender}}</td-c></template>
          <template v-if="columns[59].show"><td-c>{{list.mapSub_school_type}}</td-c></template>
          <template v-if="columns[60].show"><td-c>{{list.sub_school_name}}</td-c></template>
          <template v-if="columns[61].show"><td-c>{{list.mapSub_school_stage}}</td-c></template>
          <template v-if="columns[62].show"><td-c>{{list.mapSub_grade}}</td-c></template>
          <template v-if="columns[63].show"><td-c>{{list.achievement}}</td-c></template>
          <template v-if="columns[64].show"><td-c>{{list.learning}}</td-c></template>
          <template v-if="columns[65].show"><td-c>{{list.learning_start_period}}</td-c></template>
          <template v-if="columns[66].show"><td-c>{{list.learning_nervous}}</td-c></template>
          <template v-if="columns[67].show"><td-c>{{list.mapLearning_result}}</td-c></template>
          <template v-if="columns[68].show"><td-c>{{list.mapLearning_continuation}}</td-c></template>
          <template v-if="columns[69].show"><td-c>{{list.sub_achievement}}</td-c></template>
          <template v-if="columns[70].show"><td-c>{{list.sub_learning}}</td-c></template>
          <template v-if="columns[71].show"><td-c>{{list.sub_learning_start_period}}</td-c></template>
          <template v-if="columns[72].show"><td-c>{{list.sub_learning_nervous}}</td-c></template>
          <template v-if="columns[73].show"><td-c>{{list.mapSub_learning_result}}</td-c></template>
          <template v-if="columns[74].show"><td-c>{{list.mapSub_learning_continuation}}</td-c></template>
          <template v-if="columns[75].show"><td-c>{{list.attended}}</td-c></template>
          <template v-if="columns[76].show"><td-c>{{list.mapFathers_involvement}}</td-c></template>
          <template v-if="columns[77].show"><td-c>{{list.notices}}</td-c></template>
          <template v-if="columns[78].show"><td-c>{{list.sending_products}}</td-c></template>
          <template v-if="columns[79].show"><td-c>{{list.mapSending_method}}</td-c></template>
          <template v-if="columns[80].show"><td-c>{{list.sending_date}}</td-c></template>
          <template v-if="columns[81].show"><td-c>{{list.sending_time}}</td-c></template>
          <template v-if="columns[82].show"><td-c>{{list.mapTransmission_item_company}}</td-c></template>
          <template v-if="columns[83].show"><td-c>{{list.mapTransmission_item_course}}</td-c></template>
          <template v-if="columns[84].show"><td-c>{{list.mapTransmission_item_visitor}}</td-c></template>
          <template v-if="columns[85].show"><td-c>{{list.mapTransmission_item_purpose}}</td-c></template>
          <template v-if="columns[86].show"><td-c>{{list.mapTransmission_item_requiredtime}}</td-c></template>
          <template v-if="columns[87].show"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          <template v-if="columns[88].show"><td-c>{{list.note}}</td-c></template>
        </tr-c>

      </table-c>
    </div>
  </div>

</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/appointments/search?limit=' + config.LIMIT
import moment from 'moment'

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  exportUrl: url,
  pageName: 'appointment',
  pageNames: 'appointments'
}

let _ = window._
export default {
  directives: {
    focus: {
      inserted: function (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },

  props: {
    routeName: Object
  },

  data () {
    return {
      sortState: '降順',
      sortColumn: 'id',

      columnsFlg: false,

      index: 0,
      nowIndex: 0,

      // getGeo用
      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ],

      columns: [
        { code: 'sending_check', show: true, def: true, name: '体験案内' },
        { code: 'confirm_check', show: true, def: true, name: '確認TEL' },
        { code: 'id', show: false, def: false, name: 'ID' },
        { code: 'family_id', show: false, def: false, name: '家庭ID' },
        { code: 'user_id', show: false, def: false, name: '登録者' },
        { code: 'state', show: true, def: true, name: '状態' },
        { code: 'name', show: true, def: true, name: '名前' },
        { code: 'kana', show: false, def: false, name: 'かな' },
        { code: 'zip', show: false, def: false, name: '郵便番号' },
        { code: 'pref', show: false, def: false, name: '都道府県' },
        { code: 'address', show: true, def: true, name: '住所' },
        { code: 'tel1', show: true, def: true, name: '携帯TEL' },
        { code: 'tel2', show: false, def: false, name: '固定TEL' },
        { code: 'preferred_contact', show: false, def: false, name: '前日確認TEL連絡先' },
        { code: 'contact_timezone', show: false, def: false, name: '時間帯' },
        { code: 'fax', show: false, def: false, name: 'FAX' },
        { code: 'mail', show: false, def: false, name: 'MAIL' },
        { code: 'contact_date', show: false, def: false, name: '問合せ日' },
        { code: 'contact_method', show: false, def: false, name: '問合せ方法' },
        { code: 'support', show: true, def: true, name: '問合せ結果' },
        { code: 'missing_detail', show: false, def: false, name: '問合せ結果詳細' },
        { code: 'contact_later', show: false, def: false, name: '今後連絡できるか' },
        { code: 'next_contact_date', show: false, def: false, name: '次回連絡予定日' },
        { code: 'next_contact_method', show: false, def: false, name: '次回連絡手段' },
        { code: 'result', show: false, def: false, name: '営業結果' },
        { code: 'acquisition_date', show: true, def: true, name: '取得日' },
        { code: 'acquisition_date', show: true, def: true, name: '~取得日' },
        { code: 'ap_type', show: false, def: false, name: 'AP種類' },
        { code: 'medium1', show: false, def: false, name: '媒体1' },
        { code: 'medium2', show: false, def: false, name: '媒体2' },
        { code: 'medium3', show: false, def: false, name: '媒体3' },
        { code: 'hp_browse', show: false, def: false, name: 'HP閲覧' },
        { code: 'hp_type', show: false, def: false, name: 'HP種類' },
        { code: 'office_id', show: false, def: false, name: '営業所' },
        { code: 'gender', show: false, def: false, name: '性別' },
        { code: 'school_type', show: false, def: false, name: '公/国/私' },
        { code: 'school_name', show: false, def: false, name: '学校名' },
        { code: 'school_stage', show: false, def: false, name: '小/中/高/幼' },
        { code: 'grade', show: false, def: false, name: '学年' },
        { code: 'memo', show: false, def: false, name: 'APメモ' },
        { code: 'dm', show: false, def: false, name: 'DM届いた月' },
        { code: 'dm_information', show: false, def: false, name: 'DM情報' },
        { code: 'shop_type', show: false, def: false, name: '店種類' },
        { code: 'shop_name', show: false, def: false, name: '店名' },
        { code: 'visit_date', show: true, def: true, name: '訪問日' },
        { code: 'visit_time', show: true, def: true, name: '訪問時間' },
        { code: 'next_visit_date', show: true, def: true, name: '保留上げ日' },
        { code: 'next_visit_time', show: true, def: true, name: '保留上げ時間' },
        { code: 'request_of_day_of_week', show: false, def: false, name: '希望曜日' },
        { code: 'request_of_day_of_week_note', show: false, def: false, name: '希望曜日備考' },
        { code: 'person', show: false, def: false, name: 'AP対応者' },
        { code: 'contact_person', show: false, def: false, name: '話した相手' },
        { code: 'parking', show: false, def: false, name: '駐車場' },
        { code: 'parking_note', show: false, def: false, name: '駐車場備考' },
        { code: 'sub_f_name', show: false, def: false, name: 'サブ名前1' },
        { code: 'sub_l_name', show: false, def: false, name: 'サブ名前2' },
        { code: 'sub_f_name_kana', show: false, def: false, name: 'サブかな1' },
        { code: 'sub_l_name_kana', show: false, def: false, name: 'サブかな2' },
        { code: 'sub_gender', show: false, def: false, name: 'サブ性別' },
        { code: 'sub_school_type', show: false, def: false, name: 'サブ公/国/私' },
        { code: 'sub_school_name', show: false, def: false, name: 'サブ学校名' },
        { code: 'sub_school_stage', show: false, def: false, name: 'サブ小/中/高/幼' },
        { code: 'sub_grade', show: false, def: false, name: 'サブ学年' },
        { code: 'achievement', show: false, def: false, name: 'メイン成績' },
        { code: 'learning', show: false, def: false, name: 'メイン習い事' },
        { code: 'learning_start_period', show: false, def: false, name: 'メイン習い事いつから' },
        { code: 'learning_nervous', show: false, def: false, name: 'メイン習い事きっかけ' },
        { code: 'learning_result', show: false, def: false, name: 'メイン習い事成果' },
        { code: 'learning_continuation', show: false, def: false, name: 'メイン習い事継続' },
        { code: 'sub_achievement', show: false, def: false, name: 'サブ成績' },
        { code: 'sub_learning', show: false, def: false, name: 'サブ習い事' },
        { code: 'sub_learning_start_period', show: false, def: false, name: 'サブ習い事いつから' },
        { code: 'sub_learning_nervous', show: false, def: false, name: 'サブ習い事きっかけ' },
        { code: 'sub_learning_result', show: false, def: false, name: 'サブ習い事成果' },
        { code: 'sub_learning_continuation', show: false, def: false, name: 'サブ習い事継続' },
        { code: 'attended', show: false, def: false, name: '当日の同席者' },
        { code: 'fathers_involvement', show: false, def: false, name: '父親の絡み' },
        { code: 'notices', show: false, def: false, name: '特記事項' },
        { code: 'sending_products', show: false, def: false, name: '送るもの' },
        { code: 'sending_method', show: false, def: false, name: '送る方法' },
        { code: 'sending_date', show: false, def: false, name: '郵送・FAX / 予定日' },
        { code: 'sending_time', show: false, def: false, name: '送信時間' },
        { code: 'transmission_item_company', show: false, def: false, name: '会社名' },
        { code: 'transmission_item_course', show: false, def: false, name: '2通りの教え方' },
        { code: 'transmission_item_visitor', show: false, def: false, name: '体験はAD' },
        { code: 'transmission_item_purpose', show: false, def: false, name: '勧誘する目的' },
        { code: 'transmission_item_requiredtime', show: false, def: false, name: '体験は2時間' },
        { code: 'created_at', show: false, def: false, name: '作成日' },
        { code: 'note', show: false, def: false, name: '備考' }
      ],

      search: {
        sending_check: '',
        confirm_check: '',
        id: '',
        family_id: '',
        user_id: '',
        state: '',
        name: '',
        kana: '',
        zip: '',
        pref: '',
        address: '',
        tel1: '',
        tel2: '',
        preferred_contact: '',
        contact_timezone: '',
        fax: '',
        mail: '',
        contact_date: '',
        contact_method: '',
        support: '',
        missing_detail: '',
        contact_later: '',
        next_contact_date: '',
        next_contact_method: '',
        result: '',
        acquisition_date: [],
        ap_type: '',
        medium1: '',
        medium2: '',
        medium3: '',
        hp_browse: '',
        hp_type: '',
        office_id: '',
        gender: '',
        school_type: '',
        school_name: '',
        school_stage: '',
        grade: '',
        memo: '',
        dm: '',
        dm_information: '',
        shop_type: '',
        shop_name: '',
        visit_date: '',
        visit_time: '',
        next_visit_date: '',
        next_visit_time: '',
        request_of_day_of_week: '',
        request_of_day_of_week_note: '',
        person: '',
        note: '',
        sending_date: '',
        sending_time: '',
        contact_person: '',
        parking: '',
        parking_note: '',
        sub_f_name: '',
        sub_l_name: '',
        sub_f_name_kana: '',
        sub_l_name_kana: '',
        sub_gender: '',
        sub_school_type: '',
        sub_school_name: '',
        sub_school_stage: '',
        sub_grade: '',
        achievement: '',
        learning: '',
        learning_start_period: '',
        learning_nervous: '',
        learning_result: '',
        learning_continuation: '',
        sub_achievement: '',
        sub_learning: '',
        sub_learning_start_period: '',
        sub_learning_nervous: '',
        sub_learning_result: '',
        sub_learning_continuation: '',
        attended: '',
        fathers_involvement: '',
        notices: '',
        sending_products: '',
        sending_method: '',
        transmission_item_company: '',
        transmission_item_course: '',
        transmission_item_visitor: '',
        transmission_item_purpose: '',
        transmission_item_requiredtime: '',
        created_at: '',

        not_sending_check: '',
        not_confirm_check: '',
        not_id: '',
        not_family_id: '',
        not_user_id: '',
        not_state: '',
        not_name: '',
        not_kana: '',
        not_zip: '',
        not_pref: '',
        not_address: '',
        not_tel1: '',
        not_tel2: '',
        not_preferred_contact: '',
        not_contact_timezone: '',
        not_fax: '',
        not_mail: '',
        not_contact_date: '',
        not_contact_method: '',
        not_support: '',
        not_missing_detail: '',
        not_contact_later: '',
        not_next_contact_date: '',
        not_next_contact_method: '',
        not_result: '',
        not_acquisition_date: [],
        not_ap_type: '',
        not_medium1: '',
        not_medium2: '',
        not_medium3: '',
        not_hp_browse: '',
        not_hp_type: '',
        not_office_id: '',
        not_gender: '',
        not_school_type: '',
        not_school_name: '',
        not_school_stage: '',
        not_grade: '',
        not_memo: '',
        not_dm: '',
        not_dm_information: '',
        not_shop_type: '',
        not_shop_name: '',
        not_visit_date: '',
        not_request_of_day_of_week: '',
        not_request_of_day_of_week_note: '',
        not_person: '',
        not_note: '',
        not_sending_date: '',
        not_sending_time: '',
        not_contact_person: '',
        not_parking: '',
        not_parking_note: '',
        not_sub_f_name: '',
        not_sub_l_name: '',
        not_sub_f_name_kana: '',
        not_sub_l_name_kana: '',
        not_sub_gender: '',
        not_sub_school_type: '',
        not_sub_school_name: '',
        not_sub_school_stage: '',
        not_sub_grade: '',
        not_achievement: '',
        not_learning: '',
        not_learning_start_period: '',
        not_learning_nervous: '',
        not_learning_result: '',
        not_learning_continuation: '',
        not_sub_achievement: '',
        not_sub_learning: '',
        not_sub_learning_start_period: '',
        not_sub_learning_nervous: '',
        not_sub_learning_result: '',
        not_sub_learning_continuation: '',
        not_attended: '',
        not_fathers_involvement: '',
        not_notices: '',
        not_sending_products: '',
        not_sending_method: '',
        not_transmission_item_company: '',
        not_transmission_item_course: '',
        not_transmission_item_visitor: '',
        not_transmission_item_purpose: '',
        not_transmission_item_requiredtime: '',
        not_created_at: ''
      },

      watch: {
        sending_check: '',
        confirm_check: '',
        user_id: '',
        state: '',
        support: [],
        missing_detail: [],
        contact_later: [],
        result: '',
        ap_type: '',
        medium1: '',
        medium2: '',
        medium3: '',
        hp_browse: '',
        hp_type: '',
        office_id: '',
        pref: [],
        preferred_contact: '',
        contact_method: '',
        next_contact_method: '',
        gender: '',
        school_type: '',
        school_stage: '',
        grade: '',
        dm_information: '',
        shop_type: '',
        contact_person: '',
        parking: '',
        sub_gender: '',
        sub_school_type: '',
        sub_school_stage: '',
        sub_grade: '',
        learning_result: '',
        learning_continuation: '',
        sub_learning_result: '',
        sub_learning_continuation: '',
        attended: '',
        fathers_involvement: '',
        notices: '',
        sending_products: '',
        sending_method: '',
        transmission_item_company: '',
        transmission_item_course: '',
        transmission_item_visitor: '',
        transmission_item_purpose: '',
        transmission_item_requiredtime: '',

        not_sending_check: '',
        not_confirm_check: '',
        not_user_id: '',
        not_state: '',
        not_support: [],
        not_missing_detail: [],
        not_contact_later: [],
        not_result: '',
        not_ap_type: '',
        not_medium1: '',
        not_medium2: '',
        not_medium3: '',
        not_hp_browse: '',
        not_hp_type: '',
        not_office_id: '',
        not_pref: [],
        not_preferred_contact: '',
        not_contact_method: '',
        not_next_contact_method: '',
        not_gender: '',
        not_school_type: '',
        not_school_stage: '',
        not_grade: '',
        not_dm_information: '',
        not_shop_type: '',
        not_contact_person: '',
        not_parking: '',
        not_sub_gender: '',
        not_sub_school_type: '',
        not_sub_school_stage: '',
        not_sub_grade: '',
        not_learning_result: '',
        not_learning_continuation: '',
        not_sub_learning_result: '',
        not_sub_learning_continuation: '',
        not_attended: '',
        not_fathers_involvement: '',
        not_notices: '',
        not_sending_products: '',
        not_sending_method: '',
        not_transmission_item_company: '',
        not_transmission_item_course: '',
        not_transmission_item_visitor: '',
        not_transmission_item_purpose: '',
        not_transmission_item_requiredtime: ''
      }
    }
  },

  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    state () {
      return this.$store.getters['appointments/state']
    },

    support () {
      return this.$store.getters['appointments/support']
    },

    missing_detail () {
      return this.$store.getters['appointments/missing_detail']
    },

    contact_later () {
      return this.$store.getters['appointments/contact_later']
    },

    result () {
      return this.$store.getters['appointments/result']
    },

    ap_type () {
      return this.$store.getters['appointments/ap_type']
    },

    medium () {
      return this.$store.getters['appointments/medium']
    },

    shop_type () {
      return this.$store.getters['appointments/shop_type']
    },

    hp_type () {
      return this.$store.getters['appointments/hp_type']
    },

    hp_browse () {
      return this.$store.getters['appointments/hp_browse']
    },

    gender () {
      return this.$store.getters['appointments/gender']
    },

    school_type () {
      return this.$store.getters['appointments/school_type']
    },

    school_stage () {
      return this.$store.getters['appointments/school_stage']
    },

    grade () {
      return this.$store.getters['appointments/grade']
    },

    dm_information () {
      return this.$store.getters['appointments/dm_information']
    },

    contact_method () {
      return this.$store.getters['appointments/contact_method']
    },

    next_contact_method () {
      return this.$store.getters['appointments/next_contact_method']
    },

    contact_person () {
      return this.$store.getters['appointments/contact_person']
    },

    parking () {
      return this.$store.getters['appointments/parking']
    },

    learning_result () {
      return this.$store.getters['appointments/learning_result']
    },

    learning_continuation () {
      return this.$store.getters['appointments/learning_continuation']
    },

    fathers_involvement () {
      return this.$store.getters['appointments/fathers_involvement']
    },

    notices () {
      return this.$store.getters['appointments/notices']
    },

    sending_products () {
      return this.$store.getters['appointments/sending_products']
    },

    sending_method () {
      return this.$store.getters['appointments/sending_method']
    },

    preferred_contact () {
      return this.$store.getters['appointments/preferred_contact']
    },

    maru () {
      return this.$store.getters['appointments/maru']
    },

    appointments () {
      return this.$store.getters.appointments
    },

    offices () {
      return this.$store.getters.offices.reverse()
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    },

    orderedAppointments () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.appointments, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.appointments, this.sortColumn)
      }
    },

    mapAppointments () {
      const self = this
      return self.orderedAppointments.map(appointment => {
        appointment.mapSending_check = self.calcSelect(appointment.sending_check, 'maru')
        appointment.mapConfirm_check = self.calcSelect(appointment.confirm_check, 'maru')
        appointment.mapOffice_id = self.calcArry(appointment.office_id, 'offices')
        appointment.mapPref = self.calcArry(appointment.pref, 'prefs')
        appointment.mapState = self.calcSelect(appointment.state, 'state')
        appointment.mapPreferred_contact = self.calcSelect(appointment.preferred_contact, 'preferred_contact')
        appointment.mapContact_method = self.calcSelect(appointment.contact_method, 'contact_method')
        appointment.mapNext_contact_method = self.calcSelect(appointment.next_contact_method, 'next_contact_method')
        appointment.mapSupport = self.calcSelect(appointment.support, 'support')
        appointment.mapMissing_detail = self.calcSelect(appointment.missing_detail, 'missing_detail')
        appointment.mapContact_later = self.calcSelect(appointment.contact_later, 'contact_later')
        appointment.mapResult = self.calcSelect(appointment.result, 'result')
        appointment.mapAp_type = self.calcSelect(appointment.ap_type, 'ap_type')
        appointment.mapMedium1 = self.calcSelect(appointment.medium1, 'medium')
        appointment.mapMedium2 = self.calcSelect(appointment.medium2, 'medium')
        appointment.mapMedium3 = self.calcSelect(appointment.medium3, 'medium')
        appointment.mapHp_browse = self.calcSelect(appointment.hp_browse, 'hp_browse')
        appointment.mapHp_type = self.calcSelect(appointment.hp_type, 'hp_type')
        appointment.mapGender = self.calcSelect(appointment.gender, 'gender')
        appointment.mapSchool_type = self.calcSelect(appointment.school_type, 'school_type')
        appointment.mapSchool_stage = self.calcSelect(appointment.school_stage, 'school_stage')
        appointment.mapDmInformation = self.calcSelect(appointment.dm_information, 'dm_information')
        appointment.mapGrade = self.calcSelect(appointment.grade, 'grade')
        appointment.mapShop_type = self.calcSelect(appointment.shop_type, 'shop_type')
        appointment.mapContact_person = self.calcSelect(appointment.contact_person, 'contact_person')
        appointment.mapParking = self.calcSelect(appointment.parking, 'parking')
        appointment.mapSub_gender = self.calcSelect(appointment.sub_gender, 'gender')
        appointment.mapSub_school_type = self.calcSelect(appointment.sub_school_type, 'school_type')
        appointment.mapSub_school_stage = self.calcSelect(appointment.sub_school_stage, 'school_stage')
        appointment.mapSub_grade = self.calcSelect(appointment.sub_grade, 'grade')
        appointment.mapLearning_result = self.calcSelect(appointment.learning_result, 'learning_result')
        appointment.mapLearning_continuation = self.calcSelect(appointment.learning_continuation, 'learning_continuation')
        appointment.mapSub_learning_result = self.calcSelect(appointment.sub_learning_result, 'learning_result')
        appointment.mapSub_learning_continuation = self.calcSelect(appointment.sub_learning_continuation, 'learning_continuation')
        appointment.mapFathers_involvement = self.calcSelect(appointment.fathers_involvement, 'fathers_involvement')
        appointment.mapSending_method = self.calcSelect(appointment.sending_method, 'sending_method')
        appointment.mapTransmission_item_company = self.calcSelect(appointment.transmission_item_company, 'maru')
        appointment.mapTransmission_item_course = self.calcSelect(appointment.transmission_item_course, 'maru')
        appointment.mapTransmission_item_visitor = self.calcSelect(appointment.transmission_item_visitor, 'maru')
        appointment.mapTransmission_item_purpose = self.calcSelect(appointment.transmission_item_purpose, 'maru')
        appointment.mapTransmission_item_requiredtime = self.calcSelect(appointment.transmission_item_requiredtime, 'maru')
        return appointment
      })
    }
  },

  watch: {
    'watch.sending_check': function (now, old) {
      if (now) {
        this.search.sending_check = now.value
      } else {
        this.search.sending_check = ''
      }
    },

    'watch.not_sending_check': function (now, old) {
      if (now) {
        this.search.not_sending_check = now.value
      } else {
        this.search.not_sending_check = ''
      }
    },

    'watch.confirm_check': function (now, old) {
      if (now) {
        this.search.confirm_check = now.value
      } else {
        this.search.confirm_check = ''
      }
    },

    'watch.not_confirm_check': function (now, old) {
      if (now) {
        this.search.not_confirm_check = now.value
      } else {
        this.search.not_confirm_check = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    },

    'watch.state': function (now, old) {
      if (now) {
        this.search.state = now.value
      } else {
        this.search.state = ''
      }
    },

    'watch.not_state': function (now, old) {
      if (now) {
        this.search.not_state = now.value
      } else {
        this.search.not_state = ''
      }
    },

    'watch.support': function (now, old) {
      if (now) {
        this.search.support = ''
        for (let i = 0; i < now.length; i++) {
          this.search.support += now[i].value + ' '
        }
        this.searchTable()
      }
    },

    'watch.not_support': function (now, old) {
      if (now) {
        this.search.not_support = ''
        for (let i = 0; i < now.length; i++) {
          this.search.not_support += now[i].value + ' '
        }
        this.searchTable()
      }
    },

    'watch.missing_detail': function (now, old) {
      if (now) {
        this.search.missing_detail = ''
        for (let i = 0; i < now.length; i++) {
          this.search.missing_detail += now[i].value + ' '
        }
        this.searchTable()
      }
    },

    'watch.not_missing_detail': function (now, old) {
      if (now) {
        this.search.not_missing_detail = ''
        for (let i = 0; i < now.length; i++) {
          this.search.not_missing_detail += now[i].value + ' '
        }
        this.searchTable()
      }
    },

    'watch.contact_later': function (now, old) {
      if (now) {
        this.search.contact_later = ''
        for (let i = 0; i < now.length; i++) {
          this.search.contact_later += now[i].value + ' '
        }
        this.searchTable()
      }
    },

    'watch.not_contact_later': function (now, old) {
      if (now) {
        this.search.not_contact_later = ''
        for (let i = 0; i < now.length; i++) {
          this.search.not_contact_later += now[i].value + ' '
        }
        this.searchTable()
      }
    },

    'watch.result': function (now, old) {
      if (now) {
        this.search.result = now.value
      } else {
        this.search.result = ''
      }
    },

    'watch.not_result': function (now, old) {
      if (now) {
        this.search.not_result = now.value
      } else {
        this.search.not_result = ''
      }
    },

    'watch.ap_type': function (now, old) {
      if (now) {
        this.search.ap_type = now.value
      } else {
        this.search.ap_type = ''
      }
    },

    'watch.not_ap_type': function (now, old) {
      if (now) {
        this.search.not_ap_type = now.value
      } else {
        this.search.not_ap_type = ''
      }
    },

    'watch.medium1': function (now, old) {
      if (now) {
        this.search.medium1 = now.value
      } else {
        this.search.medium1 = ''
      }
    },

    'watch.not_medium1': function (now, old) {
      if (now) {
        this.search.not_medium1 = now.value
      } else {
        this.search.not_medium1 = ''
      }
    },

    'watch.medium2': function (now, old) {
      if (now) {
        this.search.medium2 = now.value
      } else {
        this.search.medium2 = ''
      }
    },

    'watch.not_medium2': function (now, old) {
      if (now) {
        this.search.not_medium2 = now.value
      } else {
        this.search.not_medium2 = ''
      }
    },

    'watch.medium3': function (now, old) {
      if (now) {
        this.search.medium3 = now.value
      } else {
        this.search.medium3 = ''
      }
    },

    'watch.not_medium3': function (now, old) {
      if (now) {
        this.search.not_medium3 = now.value
      } else {
        this.search.not_medium3 = ''
      }
    },

    'watch.hp_browse': function (now, old) {
      if (now) {
        this.search.hp_browse = now.value
      } else {
        this.search.hp_browse = ''
      }
    },

    'watch.not_hp_browse': function (now, old) {
      if (now) {
        this.search.not_hp_browse = now.value
      } else {
        this.search.not_hp_browse = ''
      }
    },

    'watch.hp_type': function (now, old) {
      if (now) {
        this.search.hp_type = now.value
      } else {
        this.search.hp_type = ''
      }
    },

    'watch.not_hp_type': function (now, old) {
      if (now) {
        this.search.not_hp_type = now.value
      } else {
        this.search.not_hp_type = ''
      }
    },

    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.pref': function (now, old) {
      if (now) {
        this.search.pref = ''
        for (let i = 0; i < now.length; i++) {
          this.search.pref += now[i].id + ' '
        }
        this.searchTable()
      }
    },

    'watch.not_pref': function (now, old) {
      if (now) {
        this.search.not_pref = ''
        for (let i = 0; i < now.length; i++) {
          this.search.not_pref += now[i].id + ' '
        }
        this.searchTable()
      }
    },

    'watch.preferred_contact': function (now, old) {
      if (now) {
        this.search.preferred_contact = now.value
      } else {
        this.search.preferred_contact = ''
      }
    },

    'watch.not_preferred_contact': function (now, old) {
      if (now) {
        this.search.not_preferred_contact = now.value
      } else {
        this.search.not_preferred_contact = ''
      }
    },

    'watch.contact_method': function (now, old) {
      if (now) {
        this.search.contact_method = now.value
      } else {
        this.search.contact_method = ''
      }
    },

    'watch.not_contact_method': function (now, old) {
      if (now) {
        this.search.not_contact_method = now.value
      } else {
        this.search.not_contact_method = ''
      }
    },

    'watch.next_contact_method': function (now, old) {
      if (now) {
        this.search.next_contact_method = now.value
      } else {
        this.search.next_contact_method = ''
      }
    },

    'watch.not_next_contact_method': function (now, old) {
      if (now) {
        this.search.not_next_contact_method = now.value
      } else {
        this.search.not_next_contact_method = ''
      }
    },

    'watch.gender': function (now, old) {
      if (now) {
        this.search.gender = now.value
      } else {
        this.search.gender = ''
      }
    },

    'watch.not_gender': function (now, old) {
      if (now) {
        this.search.not_gender = now.value
      } else {
        this.search.not_gender = ''
      }
    },

    'watch.school_type': function (now, old) {
      if (now) {
        this.search.school_type = now.value
      } else {
        this.search.school_type = ''
      }
    },

    'watch.not_school_type': function (now, old) {
      if (now) {
        this.search.not_school_type = now.value
      } else {
        this.search.not_school_type = ''
      }
    },

    'watch.school_stage': function (now, old) {
      if (now) {
        this.search.school_stage = now.value
      } else {
        this.search.school_stage = ''
      }
    },

    'watch.not_school_stage': function (now, old) {
      if (now) {
        this.search.not_school_stage = now.value
      } else {
        this.search.not_school_stage = ''
      }
    },

    'watch.grade': function (now, old) {
      if (now) {
        this.search.grade = now.value
      } else {
        this.search.grade = ''
      }
    },

    'watch.not_grade': function (now, old) {
      if (now) {
        this.search.not_grade = now.value
      } else {
        this.search.not_grade = ''
      }
    },

    'watch.dm_information': function (now, old) {
      if (now) {
        this.search.dm_information = now.value
      } else {
        this.search.dm_information = ''
      }
    },

    'watch.not_dm_information': function (now, old) {
      if (now) {
        this.search.not_dm_information = now.value
      } else {
        this.search.not_dm_information = ''
      }
    },

    'watch.shop_type': function (now, old) {
      if (now) {
        this.search.shop_type = now.value
      } else {
        this.search.shop_type = ''
      }
    },

    'watch.not_shop_type': function (now, old) {
      if (now) {
        this.search.not_shop_type = now.value
      } else {
        this.search.not_shop_type = ''
      }
    },

    'watch.contact_person': function (now, old) {
      if (now) {
        this.search.contact_person = now.value
      } else {
        this.search.contact_person = ''
      }
    },

    'watch.not_contact_person': function (now, old) {
      if (now) {
        this.search.not_contact_person = now.value
      } else {
        this.search.not_contact_person = ''
      }
    },

    'watch.parking': function (now, old) {
      if (now) {
        this.search.parking = now.value
      } else {
        this.search.parking = ''
      }
    },

    'watch.not_parking': function (now, old) {
      if (now) {
        this.search.not_parking = now.value
      } else {
        this.search.not_parking = ''
      }
    },

    'watch.sub_gender': function (now, old) {
      if (now) {
        this.search.sub_gender = now.value
      } else {
        this.search.sub_gender = ''
      }
    },

    'watch.not_sub_gender': function (now, old) {
      if (now) {
        this.search.not_sub_gender = now.value
      } else {
        this.search.not_sub_gender = ''
      }
    },

    'watch.sub_school_type': function (now, old) {
      if (now) {
        this.search.sub_school_type = now.value
      } else {
        this.search.sub_school_type = ''
      }
    },

    'watch.not_sub_school_type': function (now, old) {
      if (now) {
        this.search.not_sub_school_type = now.value
      } else {
        this.search.not_sub_school_type = ''
      }
    },

    'watch.sub_school_stage': function (now, old) {
      if (now) {
        this.search.sub_school_stage = now.value
      } else {
        this.search.sub_school_stage = ''
      }
    },

    'watch.not_sub_school_stage': function (now, old) {
      if (now) {
        this.search.not_sub_school_stage = now.value
      } else {
        this.search.not_sub_school_stage = ''
      }
    },

    'watch.sub_grade': function (now, old) {
      if (now) {
        this.search.sub_grade = now.value
      } else {
        this.search.sub_grade = ''
      }
    },

    'watch.not_sub_grade': function (now, old) {
      if (now) {
        this.search.not_sub_grade = now.value
      } else {
        this.search.not_sub_grade = ''
      }
    },

    'watch.learning_result': function (now, old) {
      if (now) {
        this.search.learning_result = now.value
      } else {
        this.search.learning_result = ''
      }
    },

    'watch.not_learning_result': function (now, old) {
      if (now) {
        this.search.not_learning_result = now.value
      } else {
        this.search.not_learning_result = ''
      }
    },

    'watch.learning_continuation': function (now, old) {
      if (now) {
        this.search.learning_continuation = now.value
      } else {
        this.search.learning_continuation = ''
      }
    },

    'watch.not_learning_continuation': function (now, old) {
      if (now) {
        this.search.not_learning_continuation = now.value
      } else {
        this.search.not_learning_continuation = ''
      }
    },

    'watch.sub_learning_result': function (now, old) {
      if (now) {
        this.search.sub_learning_result = now.value
      } else {
        this.search.sub_learning_result = ''
      }
    },

    'watch.not_sub_learning_result': function (now, old) {
      if (now) {
        this.search.not_sub_learning_result = now.value
      } else {
        this.search.not_sub_learning_result = ''
      }
    },

    'watch.sub_learning_continuation': function (now, old) {
      if (now) {
        this.search.sub_learning_continuation = now.value
      } else {
        this.search.sub_learning_continuation = ''
      }
    },

    'watch.not_sub_learning_continuation': function (now, old) {
      if (now) {
        this.search.not_sub_learning_continuation = now.value
      } else {
        this.search.not_sub_learning_continuation = ''
      }
    },

    'watch.attended': function (now, old) {
      if (now) {
        this.search.attended = now.value
      } else {
        this.search.attended = ''
      }
    },

    'watch.not_attended': function (now, old) {
      if (now) {
        this.search.not_attended = now.value
      } else {
        this.search.not_attended = ''
      }
    },

    'watch.fathers_involvement': function (now, old) {
      if (now) {
        this.search.fathers_involvement = now.value
      } else {
        this.search.fathers_involvement = ''
      }
    },

    'watch.not_fathers_involvement': function (now, old) {
      if (now) {
        this.search.not_fathers_involvement = now.value
      } else {
        this.search.not_fathers_involvement = ''
      }
    },

    'watch.notices': function (now, old) {
      if (now) {
        this.search.notices = now.value
      } else {
        this.search.notices = ''
      }
    },

    'watch.not_notices': function (now, old) {
      if (now) {
        this.search.not_notices = now.value
      } else {
        this.search.not_notices = ''
      }
    },

    'watch.sending_products': function (now, old) {
      if (now) {
        this.search.sending_products = now.value
      } else {
        this.search.sending_products = ''
      }
    },

    'watch.not_sending_products': function (now, old) {
      if (now) {
        this.search.not_sending_products = now.value
      } else {
        this.search.not_sending_products = ''
      }
    },

    'watch.sending_method': function (now, old) {
      if (now) {
        this.search.sending_method = now.value
      } else {
        this.search.sending_method = ''
      }
    },

    'watch.not_sending_method': function (now, old) {
      if (now) {
        this.search.not_sending_method = now.value
      } else {
        this.search.not_sending_method = ''
      }
    },

    'watch.transmission_item_company': function (now, old) {
      if (now) {
        this.search.transmission_item_company = now.value
      } else {
        this.search.transmission_item_company = ''
      }
    },

    'watch.not_transmission_item_company': function (now, old) {
      if (now) {
        this.search.not_transmission_item_company = now.value
      } else {
        this.search.not_transmission_item_company = ''
      }
    },

    'watch.transmission_item_course': function (now, old) {
      if (now) {
        this.search.transmission_item_course = now.value
      } else {
        this.search.transmission_item_course = ''
      }
    },

    'watch.not_transmission_item_course': function (now, old) {
      if (now) {
        this.search.not_transmission_item_course = now.value
      } else {
        this.search.not_transmission_item_course = ''
      }
    },

    'watch.transmission_item_visitor': function (now, old) {
      if (now) {
        this.search.transmission_item_visitor = now.value
      } else {
        this.search.transmission_item_visitor = ''
      }
    },

    'watch.not_transmission_item_visitor': function (now, old) {
      if (now) {
        this.search.not_transmission_item_visitor = now.value
      } else {
        this.search.not_transmission_item_visitor = ''
      }
    },

    'watch.transmission_item_purpose': function (now, old) {
      if (now) {
        this.search.transmission_item_purpose = now.value
      } else {
        this.search.transmission_item_purpose = ''
      }
    },

    'watch.not_transmission_item_purpose': function (now, old) {
      if (now) {
        this.search.not_transmission_item_purpose = now.value
      } else {
        this.search.not_transmission_item_purpose = ''
      }
    },

    'watch.transmission_item_requiredtime': function (now, old) {
      if (now) {
        this.search.transmission_item_requiredtime = now.value
      } else {
        this.search.transmission_item_requiredtime = ''
      }
    },

    'watch.not_transmission_item_requiredtime': function (now, old) {
      if (now) {
        this.search.not_transmission_item_requiredtime = now.value
      } else {
        this.search.not_transmission_item_requiredtime = ''
      }
    }
  },

  methods: {
    btn1 () {
      this.columns.filter(item => {
        return item.code === 'sending_check'
      })[0].show = true

      this.columns.filter(item => {
        return item.code === 'confirm_check'
      })[0].show = true

      this.columns.filter(item => {
        return item.code === 'support'
      })[0].show = true

      this.columns.filter(item => {
        return item.code === 'acquisition_date'
      })[0].show = true

      this.columns.filter(item => {
        return item.code === 'acquisition_date'
      })[1].show = true

      this.resetSearch()
      this.watch.not_sending_check = this.maru.filter(item => {
        return item.value === 1
      })[0]
      this.search.sending_products = '体験案内'
      this.search.acquisition_date[0] = moment().add('days', -2).format('YYYY-MM-DD')
      this.search.acquisition_date[1] = moment().add('days', -1).format('YYYY-MM-DD')
      this.watch.support = this.support.filter(item => {
        return item.value === 1
      })[0]
      this.searchTable()
    },

    btn2 () {
      this.resetSearch()

      this.columns.filter(item => {
        return item.code === 'visit_date'
      })[0].show = true

      this.search.visit_date = moment().add('days', 1).format('YYYY-MM-DD')
      this.searchTable()
    },

    test (e) {
      // console.log(e)
      // const indexBox = document.getElementById('index-box').scrollIntoView({ behavior: 'smooth', block: 'start' })
      const indexBox = document.getElementById('index-box')
      // console.log(indexBox)
      indexBox.scrollLeft = indexBox.scrollLeft + indexBox.offsetWidth
      // console.log(`scrollWidth: ${e.target.scrollWidth}`)
      // console.log(`scrollLeft: ${e.target.scrollLeft}`)
    },

    calcArry (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    calcSelect (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.value === val
        })[0].name
      } else {
        return
      }
    },

    next () {
      if (this.nowIndex + 1 === this.mapAppointments.length) {
        alert('これ以上進めません')
      } else {
        this.nowIndex = this.nowIndex + 1
        const arr = [
          'id',
          'family_id',
          'user_id',
          'state',
          'f_name',
          'l_kana',
          'f_name_kana',
          'l_kana_kana',
          'zip',
          'pref',
          'address1',
          'address2',
          'tel1',
          'tel2',
          'contact_date',
          'support',
          'missing_detail',
          'contact_later',
          'next_contact_date',
          'next_contact_method',
          'result',
          'acquisition_date',
          'ap_type',
          'medium1',
          'medium2',
          'medium3',
          'hp_browse',
          'hp_type',
          'office_id',
          'gender',
          'school_type',
          'school_stage',
          'grade',
          'memo',
          'dm',
          'dm_information',
          'shop_type',
          'shop_name',
          'visit_date',
          'visit_time',
          'next_visit_date',
          'next_visit_time',
          'request_of_day_of_week',
          'request_of_day_of_week_note',
          'note',
          'sending_date',
          'sending_time',
          'contact_person',
          'parking',
          'parking_note',
          'sub_f_name',
          'sub_l_name',
          'sub_f_name_kana',
          'sub_l_name_kana',
          'sub_grade',
          'sub_gender',
          'achievement',
          'learning',
          'learning_start_period',
          'learning_nervous',
          'learning_result',
          'learning_continuation',
          'sub_achievement',
          'sub_learning',
          'sub_learning_start_period',
          'sub_learning_nervous',
          'sub_learning_result',
          'sub_learning_continuation',
          'attended',
          'fathers_involvement',
          'notices',
          'sending_products',
          'sending_method',
          'created_at'
        ]
        arr.forEach((item) => {
          this.$store.state.item.appointment[item] = this.mapAppointments[this.nowIndex][item]
        })
        if (this.mapAppointments[this.nowIndex].lat === null) {
          this.$store.dispatch('getGeo', {
            this: this,
            appointment: this.mapAppointments[this.nowIndex],
            pref: this.pref
          })
        }
        this.$store.dispatch('getAppointment', this.mapAppointments[this.nowIndex].id)
        // this.$store.dispatch('getAppointments') // 座標更新したいけど検索外れるのでコメントアウト
        this.$router.push({name: this.routeName.name, params: { id: this.mapAppointments[this.nowIndex].id }})
      }
    },

    prev () {
      if (this.nowIndex + 0) {
        alert('これ以上戻れません')
      } else {
        this.nowIndex = this.nowIndex - 1
        const arr = [
          'id',
          'family_id',
          'user_id',
          'state',
          'f_name',
          'l_kana',
          'f_name_kana',
          'l_kana_kana',
          'zip',
          'pref',
          'address1',
          'address2',
          'tel1',
          'tel2',
          'contact_date',
          'support',
          'missing_detail',
          'contact_later',
          'next_contact_date',
          'next_contact_method',
          'result',
          'acquisition_date',
          'ap_type',
          'medium1',
          'medium2',
          'medium3',
          'hp_browse',
          'hp_type',
          'office_id',
          'gender',
          'school_type',
          'school_stage',
          'grade',
          'memo',
          'dm',
          'dm_information',
          'shop_type',
          'shop_name',
          'visit_date',
          'visit_time',
          'next_visit_date',
          'next_visit_time',
          'request_of_day_of_week',
          'request_of_day_of_week_note',
          'note',
          'sending_date',
          'sending_time',
          'contact_person',
          'parking',
          'parking_note',
          'sub_f_name',
          'sub_l_name',
          'sub_f_name_kana',
          'sub_l_name_kana',
          'sub_grade',
          'sub_gender',
          'achievement',
          'learning',
          'learning_start_period',
          'learning_nervous',
          'learning_result',
          'learning_continuation',
          'sub_achievement',
          'sub_learning',
          'sub_learning_start_period',
          'sub_learning_nervous',
          'sub_learning_result',
          'sub_learning_continuation',
          'attended',
          'fathers_involvement',
          'notices',
          'sending_products',
          'sending_method',
          'created_at'
        ]
        arr.forEach((item) => {
          this.$store.state.item.appointment[item] = this.mapAppointments[this.nowIndex][item]
        })
        if (this.mapAppointments[this.nowIndex].lat === null) {
          this.$store.dispatch('getGeo', {
            this: this,
            appointment: this.mapAppointments[this.nowIndex],
            pref: this.pref
          })
        }
        this.$store.dispatch('getAppointment', this.mapAppointments[this.nowIndex].id)
        // this.$store.dispatch('getAppointments') // 座標更新したいけど検索外れるのでコメントアウト
        this.$router.push({name: this.routeName.name, params: { id: this.mapAppointments[this.nowIndex].id }})
      }
    },

    linkAppointment (list, index) {
      this.nowIndex = index
      const arr = [
        'id',
        'family_id',
        'user_id',
        'state',
        'f_name',
        'l_kana',
        'f_name_kana',
        'l_kana_kana',
        'zip',
        'pref',
        'address1',
        'address2',
        'tel1',
        'tel2',
        'contact_date',
        'support',
        'missing_detail',
        'contact_later',
        'next_contact_date',
        'next_contact_method',
        'result',
        'acquisition_date',
        'ap_type',
        'medium1',
        'medium2',
        'medium3',
        'hp_browse',
        'hp_type',
        'office_id',
        'gender',
        'school_type',
        'school_stage',
        'grade',
        'memo',
        'dm',
        'dm_information',
        'shop_type',
        'shop_name',
        'visit_date',
        'visit_time',
        'next_visit_date',
        'next_visit_time',
        'request_of_day_of_week',
        'request_of_day_of_week_note',
        'note',
        'sending_date',
        'sending_time',
        'contact_person',
        'parking',
        'parking_note',
        'sub_f_name',
        'sub_l_name',
        'sub_f_name_kana',
        'sub_l_name_kana',
        'sub_grade',
        'sub_gender',
        'achievement',
        'learning',
        'learning_start_period',
        'learning_nervous',
        'learning_result',
        'learning_continuation',
        'sub_achievement',
        'sub_learning',
        'sub_learning_start_period',
        'sub_learning_nervous',
        'sub_learning_result',
        'sub_learning_continuation',
        'attended',
        'fathers_involvement',
        'notices',
        'sending_products',
        'sending_method',
        'created_at'
      ]
      arr.forEach((item) => {
        this.$store.state.item.appointment[item] = list[item]
      })
      if (list.lat === null) {
        this.$store.dispatch('getGeo', {
          this: this,
          appointment: list,
          pref: this.pref
        })
      }
      this.$store.dispatch('getAppointment', list.id)
      // this.$store.dispatch('getAppointments') // 座標更新したいけど検索外れるのでコメントアウト
      this.$router.push({name: this.routeName.name, params: { id: list.id }})
    },

    switchColumns (col) {
      this[col] = !this[col]
    },

    switchV (col) {
      this.columns[col].show = !this.columns[col].show
    },

    reset () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = false
      }
    },

    all () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = true
      }
    },

    def () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = this.columns[i].def
      }
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.watch.sending_check = 0
      this.watch.confirm_check = 0
      this.search.id = ''
      this.search.family_id = ''
      this.watch.user_id = 0
      this.watch.state = 0
      this.search.name = ''
      this.search.kana = ''
      this.search.zip = ''
      this.watch.pref = []
      this.search.address = ''
      this.search.tel1 = ''
      this.search.tel2 = ''
      this.watch.preferred_contact = 0
      this.search.contact_timezone = ''
      this.search.fax = ''
      this.search.mail = ''
      this.search.contact_date = ''
      this.watch.contact_method = 0
      this.watch.support = []
      this.watch.missing_detail = []
      this.watch.contact_later = []
      this.search.next_contact_date = ''
      this.watch.next_contact_method = 0
      this.watch.result = 0
      this.search.acquisition_date = []
      this.watch.ap_type = 0
      this.watch.medium1 = 0
      this.watch.medium2 = 0
      this.watch.medium3 = 0
      this.watch.hp_browse = 0
      this.watch.hp_type = 0
      this.watch.office_id = 0
      this.watch.gender = 0
      this.watch.school_type = 0
      this.search.school_name = ''
      this.watch.school_stage = 0
      this.watch.grade = 0
      this.search.memo = ''
      this.search.dm = ''
      this.watch.dm_information = ''
      this.watch.shop_type = 0
      this.search.shop_name = ''
      this.search.person = ''
      this.search.note = ''
      this.search.visit_date = ''
      this.search.visit_time = ''
      this.search.next_visit_date = ''
      this.search.next_visit_time = ''
      this.search.request_of_day_of_week = ''
      this.search.request_of_day_of_week_note = ''
      this.search.sending_date = ''
      this.search.sending_time = ''
      this.watch.contact_person = 0
      this.watch.parking = 0
      this.search.parking_note = ''
      this.search.sub_f_name = ''
      this.search.sub_l_name = ''
      this.search.sub_f_name_kana = ''
      this.search.sub_l_name_kana = ''
      this.watch.sub_gender = 0
      this.watch.sub_school_type = 0
      this.search.sub_school_name = ''
      this.watch.sub_school_stage = 0
      this.watch.sub_grade = 0
      this.search.achievement = ''
      this.search.learning = ''
      this.search.learning_start_period = ''
      this.search.learning_nervous = ''
      this.watch.learning_result = 0
      this.watch.learning_continuation = 0
      this.search.sub_achievement = ''
      this.search.sub_learning = ''
      this.search.sub_learning_start_period = ''
      this.search.sub_learning_nervous = ''
      this.watch.sub_learning_result = 0
      this.watch.sub_learning_continuation = 0
      this.search.attended = ''
      this.watch.fathers_involvement = 0
      this.watch.notices = 0
      this.watch.sending_products = 0
      this.watch.sending_method = 0
      this.watch.transmission_item_company = 0
      this.watch.transmission_item_course = 0
      this.watch.transmission_item_visitor = 0
      this.watch.transmission_item_purpose = 0
      this.watch.transmission_item_requiredtime = 0

      this.watch.not_sending_check = 0
      this.watch.not_confirm_check = 0
      this.search.not_id = ''
      this.search.not_family_id = ''
      this.watch.not_user_id = 0
      this.watch.not_state = 0
      this.search.not_name = ''
      this.search.not_kana = ''
      this.search.not_zip = ''
      this.watch.not_pref = []
      this.search.not_address = ''
      this.search.not_tel1 = ''
      this.search.not_tel2 = ''
      this.watch.not_preferred_contact = 0
      this.search.not_contact_timezone = ''
      this.search.not_fax = ''
      this.search.not_mail = ''
      this.search.not_contact_date = ''
      this.watch.not_contact_method = 0
      this.watch.not_support = []
      this.watch.not_missing_detail = []
      this.watch.not_contact_later = []
      this.search.not_next_contact_date = ''
      this.watch.not_next_contact_method = 0
      this.watch.not_result = 0
      this.search.not_acquisition_date = []
      this.watch.not_hp_browse = 0
      this.watch.not_ap_type = 0
      this.watch.not_medium1 = 0
      this.watch.not_medium2 = 0
      this.watch.not_medium3 = 0
      this.watch.not_hp_type = 0
      this.watch.not_office_id = 0
      this.watch.not_gender = 0
      this.watch.not_school_type = 0
      this.search.not_school_name = ''
      this.watch.not_school_stage = 0
      this.watch.not_grade = 0
      this.search.not_memo = ''
      this.search.not_dm = ''
      this.watch.not_dm_information = ''
      this.watch.not_shop_type = 0
      this.search.not_shop_name = ''
      this.search.not_person = ''
      this.search.not_note = ''
      this.search.not_visit_date = ''
      this.search.not_visit_time = ''
      this.search.not_request_of_day_of_week = ''
      this.search.not_request_of_day_of_week_note = ''
      this.search.not_sending_date = ''
      this.search.not_sending_time = ''
      this.watch.not_contact_person = 0
      this.watch.not_parking = 0
      this.search.not_parking_note = ''
      this.search.not_sub_f_name = ''
      this.search.not_sub_l_name = ''
      this.search.not_sub_f_name_kana = ''
      this.search.not_sub_l_name_kana = ''
      this.watch.not_sub_gender = 0
      this.watch.not_sub_school_type = 0
      this.search.not_sub_school_name = ''
      this.watch.not_sub_school_stage = 0
      this.watch.not_sub_grade = 0
      this.search.not_achievement = ''
      this.search.not_learning = ''
      this.search.not_learning_start_period = ''
      this.search.not_learning_nervous = ''
      this.watch.not_learning_result = 0
      this.watch.not_learning_continuation = 0
      this.search.not_sub_achievement = ''
      this.search.not_sub_learning = ''
      this.search.not_sub_learning_start_period = ''
      this.search.not_sub_learning_nervous = ''
      this.watch.not_sub_learning_result = 0
      this.watch.not_sub_learning_continuation = 0
      this.search.not_attended = ''
      this.watch.not_fathers_involvement = 0
      this.watch.not_notices = 0
      this.watch.not_sending_products = 0
      this.watch.not_sending_method = 0
      this.watch.not_transmission_item_company = 0
      this.watch.not_transmission_item_course = 0
      this.watch.not_transmission_item_visitor = 0
      this.watch.not_transmission_item_purpose = 0
      this.watch.not_transmission_item_requiredtime = 0

      this.searchTable()
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('Appointments2Search')
      let obj = JSON.parse(getjson)

      vm.watch.sending_check = obj['sending_check']
      vm.watch.confirm_check = obj['confirm_check']
      vm.search.id = obj['id']
      vm.search.family_id = obj['family_id']
      vm.watch.user_id = obj['user_id']
      vm.watch.state = obj['state']
      vm.search.name = obj['name']
      vm.search.kana = obj['kana']
      vm.search.zip = obj['zip']
      vm.watch.pref = obj['pref']
      vm.search.address = obj['address']
      vm.search.tel1 = obj['tel1']
      vm.search.tel2 = obj['tel2']
      vm.watch.preferred_contact = obj['preferred_contact']
      vm.search.contact_timezone = obj['contact_timezone']
      vm.search.fax = obj['fax']
      vm.search.mail = obj['mail']
      vm.search.contact_date = obj['contact_date']
      vm.watch.contact_method = obj['contact_method']
      vm.watch.support = obj['support']
      vm.watch.missing_detail = obj['missing_detail']
      vm.watch.contact_later = obj['contact_later']
      vm.search.next_contact_date = obj['next_contact_date']
      vm.watch.next_contact_method = obj['next_contact_method']
      vm.watch.result = obj['result']
      vm.search.acquisition_date = obj['acquisition_date']
      vm.watch.hp_browse = obj['hp_browse']
      vm.watch.ap_type = obj['ap_type']
      vm.watch.medium1 = obj['medium1']
      vm.watch.medium2 = obj['medium2']
      vm.watch.medium3 = obj['medium3']
      vm.watch.hp_type = obj['hp_type']
      vm.watch.office_id = obj['office_id']
      vm.watch.gender = obj['gender']
      vm.watch.school_type = obj['school_type']
      vm.search.school_name = obj['school_name']
      vm.watch.school_stage = obj['school_stage']
      vm.watch.grade = obj['grade']
      vm.search.memo = obj['memo']
      vm.search.dm = obj['dm']
      vm.watch.dm_information = obj['dm_information']
      vm.watch.shop_type = obj['shop_type']
      vm.search.shop_name = obj['shop_name']
      vm.search.person = obj['person']
      vm.search.note = obj['note']
      vm.search.visit_date = obj['visit_date']
      vm.search.visit_time = obj['visit_time']
      vm.search.next_visit_date = obj['next_visit_date']
      vm.search.next_visit_time = obj['next_visit_time']
      vm.search.request_of_day_of_week = obj['request_of_day_of_week']
      vm.search.request_of_day_of_week_note = obj['request_of_day_of_week_note']
      vm.search.sending_date = obj['sending_date']
      vm.search.sending_time = obj['sending_time']
      vm.watch.contact_person = obj['contact_person']
      vm.watch.parking = obj['parking']
      vm.search.parking_note = obj['parking_note']
      vm.search.sub_f_name = obj['sub_f_name']
      vm.search.sub_l_name = obj['sub_l_name']
      vm.search.sub_f_name_kana = obj['sub_f_name_kana']
      vm.search.sub_l_name_kana = obj['sub_l_name_kana']
      vm.watch.sub_gender = obj['sub_gender']
      vm.watch.sub_school_type = obj['sub_school_type']
      vm.search.sub_school_name = obj['sub_school_name']
      vm.watch.sub_school_stage = obj['sub_school_stage']
      vm.watch.sub_grade = obj['sub_grade']
      vm.search.achievement = obj['achievement']
      vm.search.learning = obj['learning']
      vm.search.learning_start_period = obj['learning_start_period']
      vm.search.learning_nervous = obj['learning_nervous']
      vm.watch.learning_result = obj['learning_result']
      vm.watch.learning_continuation = obj['learning_continuation']
      vm.search.sub_achievement = obj['sub_achievement']
      vm.search.sub_learning = obj['sub_learning']
      vm.search.sub_learning_start_period = obj['sub_learning_start_period']
      vm.search.sub_learning_nervous = obj['sub_learning_nervous']
      vm.watch.sub_learning_result = obj['sub_learning_result']
      vm.watch.sub_learning_continuation = obj['sub_learning_continuation']
      vm.search.attended = obj['attended']
      vm.watch.fathers_involvement = obj['fathers_involvement']
      vm.watch.notices = obj['notices']
      vm.watch.sending_products = obj['sending_products']
      vm.watch.sending_method = obj['sending_method']
      vm.watch.transmission_item_company = obj['transmission_item_company']
      vm.watch.transmission_item_course = obj['transmission_item_course']
      vm.watch.transmission_item_visitor = obj['transmission_item_visitor']
      vm.watch.transmission_item_purpose = obj['transmission_item_purpose']
      vm.watch.transmission_item_requiredtime = obj['transmission_item_requiredtime']
      vm.search.created_at = obj['created_at']

      vm.watch.not_sending_check = obj['not_sending_check']
      vm.watch.not_confirm_check = obj['not_confirm_check']
      vm.search.not_id = obj['not_id']
      vm.search.not_family_id = obj['not_family_id']
      vm.watch.not_user_id = obj['not_user_id']
      vm.watch.not_state = obj['not_state']
      vm.search.not_name = obj['not_name']
      vm.search.not_kana = obj['not_kana']
      vm.search.not_zip = obj['not_zip']
      vm.watch.not_pref = obj['not_pref']
      vm.search.not_address = obj['not_address']
      vm.search.not_tel1 = obj['not_tel1']
      vm.search.not_tel2 = obj['not_tel2']
      vm.watch.not_preferred_contact = obj['not_preferred_contact']
      vm.search.not_contact_timezone = obj['not_contact_timezone']
      vm.search.not_fax = obj['not_fax']
      vm.search.not_mail = obj['not_mail']
      vm.search.not_contact_date = obj['not_contact_date']
      vm.watch.not_contact_method = obj['not_contact_method']
      vm.watch.not_support = obj['not_support']
      vm.watch.not_missing_detail = obj['not_missing_detail']
      vm.watch.not_contact_later = obj['not_contact_later']
      vm.search.not_next_contact_date = obj['not_next_contact_date']
      vm.watch.not_next_contact_method = obj['not_next_contact_method']
      vm.watch.not_result = obj['not_result']
      vm.search.not_acquisition_date = obj['not_acquisition_date']
      vm.watch.not_ap_type = obj['not_ap_type']
      vm.watch.not_hp_browse = obj['not_hp_browse']
      vm.watch.not_medium1 = obj['not_medium1']
      vm.watch.not_medium2 = obj['not_medium2']
      vm.watch.not_medium3 = obj['not_medium3']
      vm.watch.not_hp_type = obj['not_hp_type']
      vm.watch.not_office_id = obj['not_office_id']
      vm.watch.not_gender = obj['not_gender']
      vm.watch.not_school_type = obj['not_school_type']
      vm.search.not_school_name = obj['not_school_name']
      vm.watch.not_school_stage = obj['not_school_stage']
      vm.watch.not_grade = obj['not_grade']
      vm.search.not_memo = obj['not_memo']
      vm.search.not_dm = obj['not_dm']
      vm.watch.not_dm_information = obj['not_dm_information']
      vm.watch.not_shop_type = obj['not_shop_type']
      vm.search.not_shop_name = obj['not_shop_name']
      vm.search.not_person = obj['not_person']
      vm.search.not_note = obj['not_note']
      vm.search.not_visit_date = obj['not_visit_date']
      vm.search.not_visit_time = obj['not_visit_time']
      vm.search.not_request_of_day_of_week = obj['not_request_of_day_of_week']
      vm.search.not_request_of_day_of_week_note = obj['not_request_of_day_of_week_note']
      vm.search.not_sending_date = obj['not_sending_date']
      vm.search.not_sending_time = obj['not_sending_time']
      vm.watch.not_contact_person = obj['not_contact_person']
      vm.watch.not_parking = obj['not_parking']
      vm.search.not_parking_note = obj['not_parking_note']
      vm.search.not_sub_f_name = obj['not_sub_f_name']
      vm.search.not_sub_l_name = obj['not_sub_l_name']
      vm.search.not_sub_f_name_kana = obj['not_sub_f_name_kana']
      vm.search.not_sub_l_name_kana = obj['not_sub_l_name_kana']
      vm.watch.not_sub_gender = obj['not_sub_gender']
      vm.watch.not_sub_school_type = obj['not_sub_school_type']
      vm.search.not_sub_school_name = obj['not_sub_school_name']
      vm.watch.not_sub_school_stage = obj['not_sub_school_stage']
      vm.watch.not_sub_grade = obj['not_sub_grade']
      vm.search.not_achievement = obj['not_achievement']
      vm.search.not_learning = obj['not_learning']
      vm.search.not_learning_start_period = obj['not_learning_start_period']
      vm.search.not_learning_nervous = obj['not_learning_nervous']
      vm.watch.not_learning_result = obj['not_learning_result']
      vm.watch.not_learning_continuation = obj['not_learning_continuation']
      vm.search.not_sub_achievement = obj['not_sub_achievement']
      vm.search.not_sub_learning = obj['not_sub_learning']
      vm.search.not_sub_learning_start_period = obj['not_sub_learning_start_period']
      vm.search.not_sub_learning_nervous = obj['not_sub_learning_nervous']
      vm.watch.not_sub_learning_result = obj['not_sub_learning_result']
      vm.watch.not_sub_learning_continuation = obj['not_sub_learning_continuation']
      vm.search.not_attended = obj['not_attended']
      vm.watch.not_fathers_involvement = obj['not_fathers_involvement']
      vm.watch.not_notices = obj['not_notices']
      vm.watch.not_sending_products = obj['not_sending_products']
      vm.watch.not_sending_method = obj['not_sending_method']
      vm.watch.not_transmission_item_company = obj['not_transmission_item_company']
      vm.watch.not_transmission_item_course = obj['not_transmission_item_course']
      vm.watch.not_transmission_item_visitor = obj['not_transmission_item_visitor']
      vm.watch.not_transmission_item_purpose = obj['not_transmission_item_purpose']
      vm.watch.not_transmission_item_requiredtime = obj['not_transmission_item_requiredtime']
      vm.search.not_created_at = obj['not_created_at']

      // for (let i = 0; i < vm.columns.length; i++) {
      //   const column = 'column_' + vm.columns[i].code
      //   vm.columns[i].show = obj[column]
      // }

      vm.searchTable()
    })
  },

  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      sending_check: this.watch.sending_check,
      confirm_check: this.watch.confirm_check,
      id: this.search.id,
      family_id: this.search.family_id,
      user_id: this.watch.user_id,
      state: this.watch.state,
      name: this.search.name,
      kana: this.search.kana,
      zip: this.search.zip,
      pref: this.watch.pref,
      address: this.search.address,
      tel1: this.search.tel1,
      tel2: this.search.tel2,
      preferred_contact: this.watch.preferred_contact,
      contact_timezone: this.search.contact_timezone,
      fax: this.search.fax,
      mail: this.search.mail,
      contact_date: this.search.contact_date,
      contact_method: this.watch.contact_method,
      support: this.watch.support,
      missing_detail: this.watch.missing_detail,
      contact_later: this.watch.contact_later,
      next_contact_date: this.search.next_contact_date,
      next_contact_method: this.watch.next_contact_method,
      result: this.watch.result,
      acquisition_date: this.search.acquisition_date,
      hp_browse: this.watch.hp_browse,
      ap_type: this.watch.ap_type,
      medium1: this.watch.medium1,
      medium2: this.watch.medium2,
      medium3: this.watch.medium3,
      hp_type: this.watch.hp_type,
      office_id: this.watch.office_id,
      gender: this.watch.gender,
      school_type: this.watch.school_type,
      school_name: this.search.school_name,
      school_stage: this.watch.school_stage,
      grade: this.watch.grade,
      memo: this.search.memo,
      dm: this.search.dm,
      dm_information: this.watch.dm_information,
      shop_type: this.watch.shop_type,
      shop_name: this.search.shop_name,
      person: this.search.person,
      note: this.search.note,
      visit_date: this.search.visit_date,
      visit_time: this.search.visit_time,
      next_visit_date: this.search.next_visit_date,
      next_visit_time: this.search.next_visit_time,
      request_of_day_of_week: this.search.request_of_day_of_week,
      request_of_day_of_week_note: this.search.request_of_day_of_week_note,
      sending_date: this.search.sending_date,
      sending_time: this.search.sending_time,
      contact_person: this.watch.contact_person,
      parking: this.watch.parking,
      parking_note: this.search.parking_note,
      sub_f_name: this.search.sub_f_name,
      sub_l_name: this.search.sub_l_name,
      sub_f_name_kana: this.search.sub_f_name_kana,
      sub_l_name_kana: this.search.sub_l_name_kana,
      sub_gender: this.watch.sub_gender,
      sub_school_type: this.watch.sub_school_type,
      sub_school_name: this.search.sub_school_name,
      sub_school_stage: this.watch.sub_school_stage,
      sub_grade: this.watch.sub_grade,
      achievement: this.search.achievement,
      learning: this.search.learning,
      learning_start_period: this.search.learning_start_period,
      learning_nervous: this.search.learning_nervous,
      learning_result: this.watch.learning_result,
      learning_continuation: this.watch.learning_continuation,
      sub_achievement: this.search.sub_achievement,
      sub_learning: this.search.sub_learning,
      sub_learning_start_period: this.search.sub_learning_start_period,
      sub_learning_nervous: this.search.sub_learning_nervous,
      sub_learning_result: this.watch.sub_learning_result,
      sub_learning_continuation: this.watch.sub_learning_continuation,
      attended: this.search.attended,
      fathers_involvement: this.watch.fathers_involvement,
      notices: this.watch.notices,
      sending_products: this.watch.sending_products,
      sending_method: this.watch.sending_method,
      transmission_item_company: this.watch.transmission_item_company,
      transmission_item_course: this.watch.transmission_item_course,
      transmission_item_visitor: this.watch.transmission_item_visitor,
      transmission_item_purpose: this.watch.transmission_item_purpose,
      transmission_item_requiredtime: this.watch.transmission_item_requiredtime,
      created_at: this.search.created_at,

      not_sending_check: this.watch.not_sending_check,
      not_confirm_check: this.watch.not_confirm_check,
      not_id: this.search.not_id,
      not_family_id: this.search.not_family_id,
      not_user_id: this.watch.not_user_id,
      not_state: this.watch.not_state,
      not_name: this.search.not_name,
      not_kana: this.search.not_kana,
      not_zip: this.search.not_zip,
      not_pref: this.watch.not_pref,
      not_address: this.search.not_address,
      not_tel1: this.search.not_tel1,
      not_tel2: this.search.not_tel2,
      not_preferred_contact: this.watch.not_preferred_contact,
      not_contact_timezone: this.search.not_contact_timezone,
      not_fax: this.search.not_fax,
      not_mail: this.search.not_mail,
      not_contact_date: this.search.not_contact_date,
      not_contact_method: this.watch.not_contact_method,
      not_support: this.watch.not_support,
      not_missing_detail: this.watch.not_missing_detail,
      not_contact_later: this.watch.not_contact_later,
      not_next_contact_date: this.search.not_next_contact_date,
      not_next_contact_method: this.watch.not_next_contact_method,
      not_result: this.watch.not_result,
      not_acquisition_date: this.search.not_acquisition_date,
      not_ap_type: this.watch.not_ap_type,
      not_hp_browse: this.watch.not_hp_browse,
      not_hp_type: this.watch.not_hp_type,
      not_medium1: this.watch.not_medium1,
      not_medium2: this.watch.not_medium2,
      not_medium3: this.watch.not_medium3,
      not_office_id: this.watch.not_office_id,
      not_gender: this.watch.not_gender,
      not_school_type: this.watch.not_school_type,
      not_school_name: this.search.not_school_name,
      not_school_stage: this.watch.not_school_stage,
      not_grade: this.watch.not_grade,
      not_memo: this.search.not_memo,
      not_dm: this.search.not_dm,
      not_dm_information: this.watch.not_dm_information,
      not_shop_type: this.watch.not_shop_type,
      not_shop_name: this.search.not_shop_name,
      not_person: this.search.not_person,
      not_note: this.search.not_note,
      not_visit_date: this.search.not_visit_date,
      not_visit_time: this.search.not_visit_time,
      not_request_of_day_of_week: this.search.not_request_of_day_of_week,
      not_request_of_day_of_week_note: this.search.not_request_of_day_of_week_note,
      not_sending_date: this.search.not_sending_date,
      not_sending_time: this.search.not_sending_time,
      not_contact_person: this.watch.not_contact_person,
      not_parking: this.watch.not_parking,
      not_parking_note: this.search.not_parking_note,
      not_sub_f_name: this.search.not_sub_f_name,
      not_sub_l_name: this.search.not_sub_l_name,
      not_sub_f_name_kana: this.search.not_sub_f_name_kana,
      not_sub_l_name_kana: this.search.not_sub_l_name_kana,
      not_sub_gender: this.watch.not_sub_gender,
      not_sub_school_type: this.watch.not_sub_school_type,
      not_sub_school_name: this.search.not_sub_school_name,
      not_sub_school_stage: this.watch.not_sub_school_stage,
      not_sub_grade: this.watch.not_sub_grade,
      not_achievement: this.search.not_achievement,
      not_learning: this.search.not_learning,
      not_learning_start_period: this.search.not_learning_start_period,
      not_learning_nervous: this.search.not_learning_nervous,
      not_learning_result: this.watch.not_learning_result,
      not_learning_continuation: this.watch.not_learning_continuation,
      not_sub_achievement: this.search.not_sub_achievement,
      not_sub_learning: this.search.not_sub_learning,
      not_sub_learning_start_period: this.search.not_sub_learning_start_period,
      not_sub_learning_nervous: this.search.not_sub_learning_nervous,
      not_sub_learning_result: this.watch.not_sub_learning_result,
      not_sub_learning_continuation: this.watch.not_sub_learning_continuation,
      not_attended: this.search.not_attended,
      not_fathers_involvement: this.watch.not_fathers_involvement,
      not_notices: this.watch.not_notices,
      not_sending_products: this.watch.not_sending_products,
      not_sending_method: this.watch.not_sending_method,
      not_transmission_item_company: this.watch.not_transmission_item_company,
      not_transmission_item_course: this.watch.not_transmission_item_course,
      not_transmission_item_visitor: this.watch.not_transmission_item_visitor,
      not_transmission_item_purpose: this.watch.not_transmission_item_purpose,
      not_transmission_item_requiredtime: this.watch.not_transmission_item_requiredtime,
      not_created_at: this.search.not_created_at
    }

    // for (let i = 0; i < this.columns.length; i++) {
    //   const column = 'column_' + this.columns[i].code
    //   obj[column] = this.columns[i].show
    // }

    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('Appointments2Search', setjson)
    next()
  }
}
</script>

<style lang="scss" scoped>
/* .sticky-1 { */
/*   position: sticky; */
/*   top: 0; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-2 { */
/*   position: sticky; */
/*   top: 24px; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-3 { */
/*   position: sticky; */
/*   top: 49px; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/*   &:after { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     bottom: -1px; */
/*   } */
/* } */
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 220px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f1b9";
    font-family: FontAwesome;
    position: absolute;
    font-size: 300px;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -150px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}

.export-modal {
  position: absolute;
  top: 0px;
  right: 0px;
}

.pager {
  padding-bottom: 5px;
}
.nowIndex {
  position: relative;
  padding: 0px 10px;
  top: -1px;
}
.fa-arrow-left, .fa-arrow-right {
  font-size: 20px;
  color: #334750;
}
.now {
  background: #41B883;
  color: #fff;
}
.men {
  color: #3F51B5;
}
.women {
  color: #E91E63;
}
</style>

<style lang="scss">
.AppointmentsIndex2 {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tag {
    margin: 1px;
    font-size: 10px;
  }
  .multiselect__tag-icon {
    line-height: 18px;
    &:after {
      font-size: 10px;
    }
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 3px 1px 1px 1px;
  }
  .multiselect__tags-wrap {
    /* background: red; */
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// AppointmentsIndex2.vue?87399d9e